import { responsiveVariables } from "../../../utilities/props.js";
import "./inset.css";
const inset = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-inset", value) };
};
export const insetTop = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-inset-top", value) };
};
export const insetBottom = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-inset-bottom", value) };
};
export const insetStart = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-inset-start", value) };
};
export const insetEnd = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-inset-end", value) };
};
export const insetInline = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-inset-inline", value) };
};
export const insetBlock = (value) => {
    if (value === undefined)
        return {};
    return { variables: responsiveVariables("--rs-inset-block", value) };
};
export default inset;
